export function isExternalHubHref(href) {
  return typeof href === 'string' && /^https?:\/\//i.test(href);
}

export function isHubEventType(postType) {
  const type = String(postType || '').toLowerCase();
  return type === 'events' || type.includes('event');
}

export function getHubItemHref(item) {
  if (!item) return null;

  const type = String(item.postType || '').toLowerCase();

  if (type.includes('news') && item.link) {
    return item.link;
  }

  const slug = item.postName;
  if (!slug) return null;

  const encoded = encodeURIComponent(slug);

  if (isHubEventType(item.postType)) {
    return `/articles/event/${encoded}`;
  }
  if (type.includes('podcast')) {
    return `/articles/podcast/${encoded}`;
  }

  return `/articles/blog/${encoded}`;
}

export function getUsecaseHref(relevance) {
  if (!relevance) return null;
  return `/articles/usecase/${encodeURIComponent(relevance)}`;
}
